"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sidebar_1 = require("primereact/sidebar");
const react_1 = __importStar(require("react"));
const SidebarHeader_1 = require("./SidebarHeader");
const MenuItems_1 = require("./MenuItems");
const sidebar_module_scss_1 = __importDefault(require("./sidebar.module.scss"));
const smart_vending_logo_white_png_1 = __importDefault(require("../../../assets/sidebar/smart-vending-logo-white.png"));
const ApiVersionRepo_1 = require("../../../modules/version/ApiVersionRepo");
const runtime_config_1 = require("../../../common/config/runtime-config");
const AuthContext_1 = require("../../../hooks/auth/context/AuthContext");
const SideBarComponent = ({ visible, onHide, items, }) => {
    const { isLoggedIn, userInfo } = (0, AuthContext_1.useAuth)();
    const frontendVersion = (0, runtime_config_1.getConfig)().VERSION;
    const [backendVersion, setBackendVersion] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        (0, ApiVersionRepo_1.getBackendVersion)().then((version) => {
            if (!version)
                return;
            setBackendVersion(version);
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(sidebar_1.Sidebar, { visible: visible, onHide: onHide, modal: false, dismissable: false, className: sidebar_module_scss_1.default.sidebar, showCloseIcon: false, content: (0, jsx_runtime_1.jsx)("div", { className: sidebar_module_scss_1.default.sidebarPanel, children: (0, jsx_runtime_1.jsx)("div", { className: sidebar_module_scss_1.default.sidebarContent, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col justify-between items-center h-full", children: [(0, jsx_runtime_1.jsxs)("div", { className: 'w-full flex flex-col items-center', children: [(0, jsx_runtime_1.jsx)(SidebarHeader_1.SidebarHeader, { tenantName: isLoggedIn ? (userInfo?.tenant ?? '') : '', onHide: onHide }), (0, jsx_runtime_1.jsx)("div", { className: "overflow-hidden w-full", children: (0, jsx_runtime_1.jsx)(MenuItems_1.MenuItems, { items: items }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'w-full flex flex-col items-center justify-center mb-5', children: [(0, jsx_runtime_1.jsx)("img", { src: smart_vending_logo_white_png_1.default, alt: "logo", style: { width: '70%' }, className: sidebar_module_scss_1.default.sidebarLogo }), (0, jsx_runtime_1.jsx)("span", { className: 'text-xs', children: `version: F ${frontendVersion} - B ${backendVersion}` })] })] }) }) }) }));
};
exports.SideBarComponent = SideBarComponent;
